const WEB3FORMS_ACCESS_KEY = "b7ecd017-1129-4c1a-a4b8-d41084242cf6";

/**
 * Global function to handle form submissions via Web3Forms.
 * This can be used by any form across the website.
 * 
 * @param {Event} event - The form submit event
 * @param {string} subject - The subject line for the email
 * @returns {Promise<{success: boolean, message: string}>}
 */
export const submitToWeb3Forms = async (event, subject = "New Form Submission") => {
  event.preventDefault();
  
  const form = event.target;
  const formData = new FormData(form);
  
  // Append Web3Forms specific required fields
  formData.append("access_key", WEB3FORMS_ACCESS_KEY);
  formData.append("subject", subject);

  try {
    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData
    });
    
    const data = await response.json();
    
    if (data.success) {
      form.reset(); // Automatically clear the form on success
      return { success: true, message: data.message || "Form submitted successfully!" };
    } else {
      return { success: false, message: data.message || "Something went wrong. Please try again." };
    }
  } catch (error) {
    console.error("Form submission error:", error);
    return { success: false, message: "A network error occurred. Please try again." };
  }
};
